import { Injectable, Inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store, select } from '@ngrx/store';
import { UserInfoService } from '../user-info.service';
import { map, catchError, flatMap, switchMap } from 'rxjs/operators';
import { LoggingService } from '../../shared/services/logging/logging.service';
import * as fromUser from '../store';
import * as fromShared from '../../shared';

@Injectable()
export class UserInfoEffects {
    constructor(
        private actions$: Actions,
        @Inject(UserInfoService) private userInfoService: UserInfoService,
        @Inject(LoggingService) private log: LoggingService
    ) {}

    UserProcessCategories$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromUser.LoadUserPermissions>(
                fromUser.UserActionTypes.LoadUserPermissions
            ),
            switchMap(action =>
                this.userInfoService.get().pipe(
                    map(
                        perms =>
                            new fromUser.SetUserPermissions({
                                ...perms,
                                UserProcessesMain: perms.UserProcessesMain.map(
                                    x => ({
                                        ...x,
                                        target: x.target ?? '_blank'
                                    })
                                ),
                                UserProcessCategories:
                                    perms.UserProcessCategories.map(x => ({
                                        ...x,
                                        UserProcesses: x.UserProcesses.map(
                                            y => ({
                                                ...y,
                                                target: y.target ?? '_blank'
                                            })
                                        )
                                    }))
                            })
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );

    LoadUserInfo$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromUser.LoadUserInfo>(
                fromUser.UserActionTypes.LoadUserInfo
            ),
            switchMap(action =>
                this.userInfoService.getUserInfo().pipe(
                    map(
                        info =>
                            new fromUser.SetUserInfo({
                                ...info
                            })
                    ),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );

    LoadUserColors$ = createEffect(() =>
        this.actions$.pipe(
            ofType<fromUser.LoadUserColors>(
                fromUser.UserActionTypes.LoadUserColors
            ),
            switchMap(x =>
                this.userInfoService.getUserColors(x.EmployeeListID).pipe(
                    map(colors => new fromUser.SetUserColors(colors)),
                    catchError(fromShared.Errors.handleServiceError)
                )
            )
        )
    );
}
